import { createRouter, createWebHistory } from 'vue-router';
import HelloWorld from '../components/HelloWorld.vue'; // 确保组件的导入路径正确
import AboutPage from '../views/AboutPage.vue'; // 组件名称首字母大写更符合规范
import ContactPage from '../views/ContactPage.vue'; // 文件名和组件名称保持一致，首字母大写
import JoinWaitlist from '../views/JoinWaitlist.vue';
import TestAnchuoorIos from '../download/TestAnchuoorIos.vue';
import PrivacyPolicy from "@/views/PrivacyPolicy.vue";

// 创建一个路由器实例
const router = createRouter({
  history: createWebHistory(), // 使用 HTML5 History 模式
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,

    },
    {
      path: '/AboutPage', // URL 路径使用短横线分隔，不使用驼峰命名
      name: 'AboutPage',
      component: AboutPage,
    },
    {
      path: '/ContactPage', // 通常 URL 路径全部使用小写
      name: 'ContactPage', // 路由名称使用短横线分隔
      component: ContactPage,
    },
    {
      path: '/JoinWaitlist', // 通常 URL 路径全部使用小写
      name: 'JoinWaitlist', // 路由名称使用短横线分隔
      component: JoinWaitlist,
    },
    {
      path: '/TestAnchuoorIos', // 通常 URL 路径全部使用小写
      name: 'TestAnchuoorIos', // 路由名称使用短横线分隔
      component: TestAnchuoorIos,
    },
    {
      path: '/PrivacyPolicy', // 通常 URL 路径全部使用小写
      name: 'PrivacyPolicy', // 路由名称使用短横线分隔
      component: PrivacyPolicy,
    },

  ],
});

export default router;
